import { ReactNode } from "react";

import { useIntl } from "react-intl";

import AccountCreation, { Login } from "@/components/signup/account-creation";
import {
    SignupBackgroundLayout,
    JSMOverlayTemplate
} from "@/components/signup/layouts";
import { useIsJsmCrossflow } from "@/components/signup/layouts/use-is-jsm-crossflow";
import { getLoginUrl, ServiceCollectionLogo } from "@/components/signup/utils";
import { Link } from "@/libraries/design/components";
import { experiments, ExperimentView } from "@/utils/experiment";

import {
    FreeForThreeAgentsText,
    GetStartedText,
    Headings,
    JSMGetStartedText,
    JSMCrossflowGetStartedText,
    InputSubmitButton,
    YourPlanIncludesText
} from "../components";

const LoggedOutContent = ({
    identityCobranding
}: {
    identityCobranding: string;
}) => {
    return (
        <>
            <Headings
                main={<GetStartedText productName="Service Collection" />}
                sub={<FreeForThreeAgentsText />}
            />
            <AccountCreation identityCobranding={identityCobranding} />
        </>
    );
};

const LoggedOutContentLofi = () => {
    const intl = useIntl();
    const isJsmCrossflow = useIsJsmCrossflow();
    const headingMain = isJsmCrossflow ? (
        <JSMCrossflowGetStartedText />
    ) : (
        <JSMGetStartedText />
    );

    const atlassianAccountLoginText = intl.formatMessage(
        {
            id: "BxpUiSignup.SignupForm.existingAtlassianAccount",
            defaultMessage:
                "Already have an Atlassian account? <logInLink>Log in</logInLink>"
        },
        {
            logInLink: (text: ReactNode) => logInLink(text, location)
        }
    );

    return (
        <>
            <Headings main={headingMain} sub={<YourPlanIncludesText />} />
            <AccountCreation
                Input={<InputSubmitButton />}
                Submit={null}
                identityCobranding="wac--service-collection-cobranding"
                Login={<Login loginText={atlassianAccountLoginText} />}
            />
        </>
    );
};

export const LoggedOut = () => (
    <ExperimentView
        experiment={experiments.servCoLofiBackground}
        render={(value) =>
            value ? (
                <JSMOverlayTemplate size="sm">
                    <LoggedOutContentLofi />
                </JSMOverlayTemplate>
            ) : (
                <SignupBackgroundLayout
                    ProductLogo={<ServiceCollectionLogo />}
                    theme="yellow"
                >
                    <LoggedOutContent identityCobranding="wac--service-collection" />
                </SignupBackgroundLayout>
            )
        }
    />
);

const logInLink = (text: ReactNode, location: Location) => (
    <Link
        text={text as unknown as string}
        aria-label={text as unknown as string}
        type="inline"
        href={getLoginUrl(location)}
    />
);
